import { render, staticRenderFns } from "./supplierSliderVerify.vue?vue&type=template&id=2c3dfd02&scoped=true&"
import script from "./supplierSliderVerify.vue?vue&type=script&lang=js&"
export * from "./supplierSliderVerify.vue?vue&type=script&lang=js&"
import style0 from "./supplierSliderVerify.vue?vue&type=style&index=0&id=2c3dfd02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3dfd02",
  null
  
)

export default component.exports